// extracted by mini-css-extract-plugin
module.exports = {"body":"DeleteAppDialog_body__v2OK4","footer":"DeleteAppDialog_footer__8HwN1"};